module.exports = __webpack_public_path__ + "img/fortune_bag.6b584f5a.png";